/**
 * Search
 *
 *
 * @module search/Search
 */

"use strict";

import Toggle from "ui/toggle/Toggle";
import Observer from "conditioner/utils/Observer";

class Search {
    constructor(element, options) {
        this._element = element;
        this._options = options;

        this._initialize();
    }

    _initialize() {
        let _toggle = new Toggle(this._element);
        Observer.subscribe(_toggle, "active", this._onActive.bind(this));
    }

    _onActive() {
        this._element.querySelector("[name=q]").focus();
    }
}

export default Search;
